import { RouteConfig } from 'config/constants/route'
import { CashbackBonusType } from 'config/types/bonus/userBonus'
import useModal from 'hooks/useModal'
import Column from 'layout/Components/Column'
import { RowMiddle } from 'layout/Components/Row'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'
import BonusDetailsModal from 'views/BonusCenter/components/BonusDetailsModal'
import { StyledButton } from '../styled'
import ContentLayout from './ContentLayout'

interface CashbackBonusInfoProps {
  bonus: CashbackBonusType
  onDismiss?: () => void
}

const CashbackBonusInfo: React.FC<CashbackBonusInfoProps> = ({ bonus, onDismiss }) => {
  const [onPresentBonusDetailModal] = useModal(BonusDetailsModal)
  const { t } = useTranslation()

  return (
    <Column width="100%" style={{ gap: '20px' }}>
      <ContentLayout
        bonus={bonus}
        activeContent={
          <>
            <StyledCashbackContent>
              🚀
              {t("You're now earning {{cashbackRate}}% cashback on your gameplay.", {
                cashbackRate: bonus.cashbackRate,
              })}
            </StyledCashbackContent>
            <StyledCashbackContent mt="0px">
              <Trans>Enjoy boosted returns during this bonus period</Trans>!
            </StyledCashbackContent>
          </>
        }
        inactiveContent={
          <StyledCashbackContent>
            ⚠️
            <Trans>
              You've finished a Cashback Bonus during this period. Regular cashback won't be available again until the
              next cycle.
            </Trans>
          </StyledCashbackContent>
        }
      />

      <RowMiddle style={{ gap: '8px' }}>
        <StyledButton
          style={{
            justifyContent: 'center',
            fontWeight: 'bold',
          }}
          fontSize={['14px', '', '12px']}
          mt="8px"
          onClick={() => {
            onPresentBonusDetailModal({ bonus })
            onDismiss()
          }}
        >
          <Trans>Bonus Details</Trans>
        </StyledButton>
        <StyledButton
          style={{
            justifyContent: 'center',
            fontWeight: 'bold',
          }}
          fontSize={['14px', '', '12px']}
          mt="8px"
          as={Link}
          onClick={onDismiss}
          href={RouteConfig.Cashback}
        >
          <Trans>My Cashback</Trans>
        </StyledButton>
      </RowMiddle>
    </Column>
  )
}

const StyledCashbackContent = styled(Text)`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSubtle};
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.24px;
  word-break: break-word;
  white-space: break-spaces;
  max-width: 352px;
  margin-top: 8px;
`

export default CashbackBonusInfo
